import Axios from 'axios';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';


const getDefaultState = () => {
  return {
    token: '',
    user: {},
    last_selected_pool: null,
    vote_tick: 0
  };
};

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: getDefaultState(),
  getters: {
    isLoggedIn: (state) => {
      return state.token;
    },
    getUser: (state) => {
      return state.user;
    },
    getLastSelectedPool: (state) => {
      return state.last_selected_pool;
    },
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_LAST_SELECTED_POOL: (state, pool_id) => {
      state.last_selected_pool = pool_id;
    },
    INCREMENT_VOTE_TICK: (state) => {
      state.vote_tick++;
    },
    RESET: (state) => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    // eslint-disable-next-line
    login: ({ commit, dispatch }, { token, user }) => {
      commit("SET_TOKEN", token);
      commit("SET_USER", user);

      // set auth header
      Axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },
    updateLastSelectedPool: ({commit}, {pool_id}) => {
      commit("SET_LAST_SELECTED_POOL", pool_id)
    },
    notifyVoteCast: ({commit}) => {
      commit("INCREMENT_VOTE_TICK")
    },
    logout: ({ commit }) => {
      commit("RESET", "");
    },
  },
});
